/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import DataGridComponent from '../../../../Components/DataGrid/dataGrid';
import '../../NewRequest/techSession.scss';

const UserDataGrid = ({
  filteredRows,
  columns,
  handleRowSelectionChange,
  isEdit,
  checkboxDisabled,
  dataColumns,
  allSelected,
  onSelectAllChange,
  checkboxHeaderLabel,
  hideSeparator,
}) => (
  <div className="tech-session-users-data-grid-container">
    {filteredRows && (
      <DataGridComponent
        dataRows={filteredRows}
        dataColumns={dataColumns}
        isFilteredRows={filteredRows}
        sortFilterColumns={(columns || []).map((column) => column.field)}
        pageSize={10}
        onRowSelectionChange={handleRowSelectionChange}
        dataGridCss="tech-session-user-management-data-grid"
        isEdit={isEdit}
        checkboxDisabled={checkboxDisabled}
        allSelected={allSelected}
        onSelectAllChange={onSelectAllChange}
        checkboxHeaderLabel={checkboxHeaderLabel}
        hideSeparator={hideSeparator}
      />
    )}
  </div>
);

UserDataGrid.propTypes = {
  filteredRows: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  handleRowSelectionChange: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  checkboxDisabled: PropTypes.bool,
  dataColumns: PropTypes.array.isRequired,
  allSelected: PropTypes.bool,
  onSelectAllChange: PropTypes.func,
  hideSeparator:  PropTypes.bool,
};

export default UserDataGrid;